export const formatBookingData = (data: any[] = []) => {
  return data.map(item => {
    const user = item.user || {};
    const venue = item.venue || {};
    const billing = item.billingAddress || {};
    const chef = item.chef || {};
    const fare = item.fareObject || {};

    return {
      // Basic
      id: item.id,
      requirement: item.requirement || '-',
      meals: Array.isArray(item.meals) ? item.meals.join(', ') : '-',

      // Date & Time
      startDate: item.startDate,
      startTime: item.startTime,
      endTime: item.endTime,

      // Customer
      customerName: [user.firstName, user.lastName].filter(Boolean).join(' ') || 'Unknown',

      // Addresses
      venueAddress: [venue.address, venue.city].filter(Boolean).join(', '),
      billingAddress: [billing.address, billing.city].filter(Boolean).join(', '),

      // Booking info
      headCount: item.headCount || 0,

      // Chef
      chefId: chef.id || '',
      chefName: [chef.firstName, chef.lastName].filter(Boolean).join(' ') || 'Not Assigned',

      // Ratings
      chefRating: item.chefRating?.rating ?? '-',
      userRating: item.userRating?.rating ?? '-',

      // Fare
      chefFare: item.chefFare ?? fare.chefFare ?? 0,
      cleanerFare: item.cleanerFare ?? 0,
      totalAmount: fare.totalPrice ?? 0,

      // Status
      status: item.status,
      createdAt: item.createdAt,
    };
  });
};